/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetSales200ResponseAllOfData } from './GetSales200ResponseAllOfData';
import {
    GetSales200ResponseAllOfDataFromJSON,
    GetSales200ResponseAllOfDataFromJSONTyped,
    GetSales200ResponseAllOfDataToJSON,
} from './GetSales200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetSales200Response
 */
export interface GetSales200Response {
    /**
     * 
     * @type {GetSales200ResponseAllOfData}
     * @memberof GetSales200Response
     */
    data: GetSales200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetSales200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetSales200Response interface.
 */
export function instanceOfGetSales200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetSales200ResponseFromJSON(json: any): GetSales200Response {
    return GetSales200ResponseFromJSONTyped(json, false);
}

export function GetSales200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSales200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetSales200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetSales200ResponseToJSON(value?: GetSales200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetSales200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

